import {DeletedImage} from '../resources/DeletedImage';
import {DomainEvent} from './DomainEvent';

export class ImageDeleted extends DomainEvent<DeletedImage>{ };
